import { NextPage } from "next";

const HomePage: NextPage = () => <p>You probably should not be here</p>;

export default HomePage;

export { getServerSideProps } from "../services/server-side.props";
